import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';
import NavActions from '../actions';
import setBodyOverflow from '../utils/bodyUtils';
import root from 'window-or-global';

let cookiesEnabled = false;
if ((root.navigator && root.navigator.cookieEnabled && root.document && root.document.cookie !== undefined) || root.__server_side_render) {
    cookiesEnabled = true;
}

@seamlessImmutable
class NavStore {
    constructor() {
        this.state = Immutable({
            searchActive: false, //tracks whether or not the search area is active
            mobileNavActive: false, //track whether or not the mobile menu is active
            mobileNavActiveLinks: false, //track whether or not the mobile menu should show the nav links
            tabletNavActive: false, //track whether or not the tablet hamburger menu is active,
            mobileUserActive: false, //track whether or not the user mobile menu is active,
            mobileLocaleActive: false, //track whether or not the tablet hamburger menu is active,
            mobileActiveLinkIndex: null, //tracks the index of the link which is showing kids options
            euCookieAccepted: false //show/hide EU cookie message
        });

        this.bindActions(NavActions);
    }

    onCloseMobileTablet() {
        this.setState(this.state.merge({
            mobileNavActive: false,
            mobileNavActiveLinks: false,
            mobileActiveLinkIndex: null,
            tabletNavActive: false,
            searchActive: false
        }));

        setBodyOverflow(false);
    }

    onSearchActive(isActive) {
        if (this.state.searchActive === isActive) return; //no change

        this.setState(this.state.merge({
            searchActive: isActive
        }));
    }

    onMobileNavActive(isActive) {
        if (this.state.mobileNavActive === isActive) return; //no change

        this.setState(this.state.merge({
            mobileNavActive: isActive
        }));

        setBodyOverflow(isActive);
    }

    onCTAclick(isActive) {
        if (this.state.mobileNavActive === isActive) return; //no change

        this.setState(this.state.merge({
            mobileNavActive: isActive
        }));
        setBodyOverflow(false);
    }

    onMobileLocaleActive(isActive) {
        if (this.state.mobileLocaleActive === isActive) return; //no change

        this.setState(this.state.merge({
            mobileLocaleActive: isActive
        }));
    }

    onMobileUserActive(isActive) {
        if (this.state.mobileUserActive === isActive) return; //no change

        this.setState(this.state.merge({
            mobileUserActive: isActive
        }));
    }

    onMobileActiveLinkIndex(index) {
        if (this.state.mobileActiveLinkIndex === index) return; //no change

        this.setState(this.state.merge({
            mobileActiveLinkIndex: index
        }));
    }

    onTabletNavActive(isActive) {
        if (this.state.tabletNavActive === isActive) return; //no change

        this.setState(this.state.merge({
            tabletNavActive: isActive
        }));

        setBodyOverflow(isActive);
    }

    onMobileNavActiveLinks(isActive) {
        if (this.state.mobileNavActiveLinks === isActive) return; //no change

        this.setState(this.state.merge({
            mobileNavActiveLinks: isActive
        }));
    }

    onEuCookieMessageClose(cookies) {
        if (cookiesEnabled) {
            let host = root.location.hostname;
            const re = /([\w-]+\.[\w-]+)$/g;
            const matches = host.match(re);
            //remove any subdomain
            if (matches && matches.length) {
                host = matches[0];
            }

            const expires = new Date('12-31-9999');
            const domain = `.${host}`;
            const options = {expires, domain, path: '/'};
            if (host === 'localhost') {
                delete options.domain;
            }

            cookies.set('euCookieAccepted', 'true', options);
        }

        this.setState(this.state.merge({
            euCookieAccepted: true
        }));
    }

    onSetEuCookieAccepted(euCookieAccepted) {
        this.setState(this.state.merge({
            euCookieAccepted
        }));
    }
}

export default alt.createStore(NavStore, 'NavStore');
